import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
import { NavLink } from "react-router-dom";
//Components
import { useEffect, useState } from "react";
import ActionButton from "../../components/Button/ActionButton";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Details from "../../components/Modals/Lens/Details";
import Delete from "../../components/Modals/Delete";
import UpdateLens from "../../components/Modals/Lens/Update";
import DeleteAll from "../../components/Modals/DeleteAll";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenu";
import TitleMenu from "../../components/Title/TitleMenu";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
//Hooks
import useLoading from "../../hooks/useLoading";
import { useCheckbox } from "../../hooks/useCheckbox";
import { useMultipleModal } from "../../hooks/useMultipleModal";
import { apiExport } from "../../hooks/apiExport";
//Interface
import { ILens } from "Interfaces/ILens";
import { IPage } from "Interfaces/IPage";
//Icons
import { Trash } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";

export default function Lens() {
  const [data, setData] = useState<ILens[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const [selectAll, setSelectAll] = useState(false);

  //Header da tabela
  const listHeaderTable = [
    "Nome",
  ];
  //Pop menu dos Dados
  const tablePopMenu = ["Detalhes", "Editar", "Excluir"];

  //Pop menu do botão New
  const titleListPopMenu = [
    "Lente",
    "Altura",
    "Antirreflexo",
    "Diâmetro",
    "Fotossensibilidade",
    "Índice",
    "Laboratório",
    "Surfaçagem",
    "Tipo de Lente",
  ];
  const titlePopButtton = [
    "lens",
    "height",
    "anti-glare",
    "diameter",
    "sensitivity",
    "index",
    "laboratory",
    "surfacing",
    "type-lens",
  ];

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/lens?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm.trim()) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      const dataResponse = response.data;

      setData(dataResponse.data);
      setCurrentPage(dataResponse);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  const DeleteAllModal = () => {
    toggleModalVisibility("deleteAll");
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Seleciona todos os IDs
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);
    } else {
      // Desmarca todos os IDs
      CleanSelectIds();
    }
  };

  const handleCheckChange = (id: number) => {
    toggleCheckbox(id);
  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  const exportData = async () => {
    startLoading();
    try {
      await apiExport("/lens-export-pdf"); // Passe a URL diretamente
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  return (
    <S.Container>
      <S.Content>
        <TitleMenu
          filterSearch={handleSearchChange}
          title="Estoque de Lentes"
          subtitle="Gerencie seu estoque de lentes"
          placeholderSearch="Nome da Lente"
          listPopMenu={titleListPopMenu}
          fetchData={fetchData}
          listPopButton={titlePopButtton}
          exportButton={exportData}
        />
        {isLoading ? (
          <Loading />
        ) : (
          <S.ContaintableButton>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <ActionButton
                  Icon={<Trash size={24} />}
                  onClick={DeleteAllModal}
                />
              )}
            </S.ContentButton>
            <S.ContentTable>
              <thead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {listHeaderTable.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={() => handleCheckChange(val.id)}
                          type="checkbox"
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>
                        <NavLink
                          to='/estoque'
                          state={{ id: val.id }}
                          style={{ color: "black", textDecoration: "none" }}
                          key={index + 1}>
                          <S.ButtonNav>
                            {val.name_lens || "-"}
                          </S.ButtonNav>
                        </NavLink>
                      </td>
                      <td>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu
                              listName={tablePopMenu}
                              onClickHandlers={[
                                () => toggleModalVisibility("details"),
                                () => toggleModalVisibility("update"),
                                () => toggleModalVisibility("delete"),
                              ]}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </tbody>
            </S.ContentTable>
          </S.ContaintableButton>
        )}
      </S.Content>

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
        />
      )}
      {
        isOpenModal("update") &&
        <UpdateLens
          isOpenModalLens={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          refreshData={fetchData}
        />
      }
      {
        isOpenModal("details") &&
        <Details
          isOpenModalDetails={isOpenModal("details")}
          setModalClose={() => toggleModalVisibility("details")}
          selectedUrlId={openModalOptId}
        />
      }

      <Delete
        updateList={fetchData}
        endpoint="lens"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />

      <DeleteAll
        setResponse={handleDeleteResponse}
        updateList={fetchData}
        data={selectedIds}
        endpoint="lens-delete-multiple"
        isOpenModal={isOpenModal("deleteAll")}
        setModalClose={() => toggleModalVisibility("deleteAll")}
      />
    </S.Container>
  );
}
